<qwyk-shipment-tracking-events-list
    [loading]="loading$ | async"
    [events]="shipmentTrackingEvents$ | async"
    [showInternalEvents]="false"
    [dateFormat]="dateFormat$ | async"
    headerClass="p-lg-4"
    headingClass="font-weight-normal"
/>
